import { MyProfileRespDtoDTO } from '@hem/portal-query'

import { getAxios } from './axios-instance'
import APIS from './constants'

export const getMyProfile = (token: string): Promise<MyProfileRespDtoDTO> => {
  const api = getAxios()
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`
  return api.get(APIS.accounts.myProfile).then((response) => response.data.data)
}
